import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import truncateText from '../utils/truncateText';

const FeedComponent = ({
  feedUrl,
  title,
  description,
  type,
  section,
  imageUrl,
  publishDate,
  updatedDate,
  byline,
  isDarkTheme,
}) => {
  return (
    <div className="py-8 flex flex-wrap md:flex-nowrap justify-center feed-container-layout">
      <div className="md:w-64 md:mb-0 mb-6 flex-shrink-0 flex flex-col feed-container">
        <span
          className={classNames(
            'font-semibold title-font mb-8',
            { 'text-gray-700': !isDarkTheme },
            { 'text-white': isDarkTheme },
          )}
        >
          {`${type} - ${section}`}
        </span>
        <span
          className={classNames(
            'mt-1 text-sm',
            { 'text-gray-700': !isDarkTheme },
            { 'text-white': isDarkTheme },
          )}
        >
          {`Published Date: ${new Date(publishDate).toDateString()}`}
        </span>
        <span
          className={classNames(
            'mt-1 text-sm',
            { 'text-gray-700': !isDarkTheme },
            { 'text-white': isDarkTheme },
          )}
        >
          {`Last Updated on: ${new Date(updatedDate).toDateString()}`}
        </span>
      </div>
      <div className="md:flex-grow">
        <div className="container mx-auto flex md:flex-row flex-col items-center feed-container-content">
          <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6 mb-10 md:mb-0 feed-container-content-image">
            <img className="object-cover object-center rounded" alt={title} src={imageUrl} />
          </div>
          <div className="lg:flex-grow md:w-1/2 flex flex-col md:items-start md:text-left items-center text-center feed-container-content-data">
            <h1
              className={classNames(
                'title-font sm:text-4xl text-3xl mb-4 font-medium',
                { 'text-gray-900': !isDarkTheme },
                { 'text-white': isDarkTheme },
              )}
            >
              {truncateText(title, 72, '...')}
            </h1>
            <p className="mb-4 leading-relaxed">{truncateText(description, 175, '...')}</p>
            <p className="mb-4 leading-relaxed feed-container-content-data-link">{byline}</p>
            {feedUrl && (
              <a
                href={feedUrl}
                className={classNames(
                  'flex justify-center items-center py-2 feed-container-content-data-link',
                  { 'text-blue-800': !isDarkTheme },
                  { 'text-indigo-400': isDarkTheme },
                )}
                aria-label={`View More about ${title}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                View More
                <svg
                  className="w-4 h-4 ml-2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M5 12h14" />
                  <path d="M12 5l7 7-7 7" />
                </svg>
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

FeedComponent.propTypes = {
  isDarkTheme: PropTypes.bool.isRequired,
  feedUrl: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  type: PropTypes.string,
  section: PropTypes.string,
  imageUrl: PropTypes.string,
  publishDate: PropTypes.string,
  updatedDate: PropTypes.string,
  byline: PropTypes.string,
};

export default FeedComponent;
